module.exports = __webpack_public_path__ + "img/system.cc447182.svg";